module.exports = __webpack_public_path__ + "media/images/recruit/recruitmentlist/il_sales-c245dc6287eb1e654982e19ac85af770.png";